module.exports = __webpack_public_path__ + "static/20230619_185-82a3c781d866550a5d1dd2567328a422.jpg";